import palette from './palette'

export default {
    MuiButton: {
        root: {
            borderRadius: 6,
        },
    },
    MuiTextField: {
        root: {
            borderRadius: 6,
        },
    },
    MuiOutlinedInput: {
        root: {
            borderRadius: 6,
        },
    },
    MuiFilledInput: {
        root: {
            borderRadius: 6,
        },
    },
    MuiSelect: {
        root: {
            borderRadius: 0,
        },
    },
    MuiInputBase: {
        root: {
            borderRadius: 0,
        },
    },
    MuiChip: {
        root: {
            borderRadius: 4,
        },
    },
    MuiInput: {
        root: {
            borderRadius: 0,
        },
    },
    MuiDialogTitle: {
        root: {
            paddingTop: 16,
            paddingBottom: 16,
            backgroundColor: palette.primary.main,
            color: `${palette.white} !important`,
        },
    },
    MuiDialogActions: {
        root: {
            paddingTop: 16,
            paddingBottom: 16,
            paddingRight: 24,
            backgroundColor: palette.primary.main,
            color: `${palette.white} !important`,
        },
    },
    MuiDialogContent: {
        root: {
            backgroundColor: palette.white,
            paddingTop: 16,
            paddingBottom: 16,
        },
    },
    MuiDialogContentText: {
        root: {
            backgroundColor: palette.white,
            fontSize: 18,
            paddingTop: 2,
            paddingBottom: 12,
        },
    },
    MuiAlert: {
        root: {
            fontSize: 16,
        },
    },
    MuiTableSortLabel: {
        root: {
            color: `${palette.white} !important`,
        },
        icon: {
            color: `${palette.white} !important`,
        },
    },
    MuiTableCell: {
        head: {
            paddingLeft: `8px !important`,
        },
    },
}
